import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Typography,
} from '@mui/material';

const InviteHomeownerDialog = ({ open, onClose, inviteEmail, onEmailChange, onSubmit }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>Invite Homeowner</DialogTitle>
    <DialogContent>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Send an email invitation to the homeowner to join this project. They'll receive a link to create their account and access the project.
      </Typography>
      <TextField
        autoFocus
        margin="dense"
        label="Homeowner Email"
        type="email"
        fullWidth
        variant="outlined"
        value={inviteEmail}
        onChange={(e) => onEmailChange(e.target.value)}
        placeholder="homeowner@example.com"
        sx={{ mt: 1 }}
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button
        onClick={onSubmit}
        variant="contained"
        color="secondary"
        disabled={!inviteEmail.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inviteEmail)}
      >
        Send Invitation
      </Button>
    </DialogActions>
  </Dialog>
);

export default InviteHomeownerDialog;
